module.exports = __webpack_public_path__ + "static/media/play.d2df9e7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/play.svg
// module id = 222
// module chunks = 0